import { Link } from "react-router-dom";

export default function HomeHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20manga%20aesthetic%20background%2C%20soft%20warm%20gradient%20from%20light%20teal%20to%20warm%20beige%20cream%20tones%2C%20abstract%20flowing%20curves%20and%20organic%20shapes%2C%20minimalist%20artistic%20illustration%20style%2C%20dreamy%20atmospheric%20mood%2C%20delicate%20floating%20particles%2C%20ethereal%20light%20effects%2C%20cinematic%20composition%2C%20no%20text%20no%20people&width=1920&height=1080&seq=hero-bg-home-01&orientation=landscape"
          alt="韩漫大全漫画网 - 下拉式免费韩漫在线阅读"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 h-full w-full px-4 md:px-6 flex flex-col justify-center">
        <div className="max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
            韩漫大全漫画网<br />下拉式免费阅读
          </h1>
          <p className="text-white/80 text-sm md:text-base max-w-lg mb-8 leading-relaxed">
            海量无删减韩漫资源，每日200+话更新。支持PC和手机端下拉式在线观看，恋爱、奇幻、热血、悬疑全类型覆盖，满足你多样化的阅读需求。
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap text-center hover:bg-primary-600 transition-all cursor-pointer"
            >
              立即免费阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/20 text-white border border-white/30 rounded-full text-sm font-medium whitespace-nowrap text-center hover:bg-white/30 transition-all cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-10 h-10 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}